import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useLanguage } from "@shared/contexts/LanguageContext";

const FontSizeControl = () => {
  const { fontSize, setFontSize, t } = useLanguage();
  const [showOptions, setShowOptions] = useState(false);

  const sizeOptions = [
    { value: "small", label: { en: "Small", tc: "小", sc: "小" } },
    { value: "medium", label: { en: "Medium", tc: "中", sc: "中" } },
    { value: "large", label: { en: "Large", tc: "大", sc: "大" } },
  ];

  const currentOption = sizeOptions.find((s) => s.value === fontSize);
  const currentLabel = currentOption
    ? t(currentOption.label)
    : t({ en: "Medium", tc: "中", sc: "中" });

  const handleSelect = (value) => {
    setFontSize(value);
    setShowOptions(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setShowOptions(!showOptions)}
        className="flex items-center gap-1 px-3 py-1.5 rounded-lg bg-white/10 text-white text-sm font-medium hover:bg-white/20 transition-colors"
        data-testid="fontsize-selector"
      >
        <span className="text-white/60 mr-1">
          {t({ en: "Text:", tc: "字體:", sc: "字体:" })}
        </span>
        {currentLabel}
        <ChevronDown
          className={`w-3 h-3 transition-transform ${showOptions ? "rotate-180" : ""}`}
        />
      </button>

      {showOptions && (
        <div className="absolute bottom-full mb-1 right-0 bg-zinc-800 rounded-lg shadow-lg border border-white/20 overflow-hidden z-10">
          {sizeOptions.map((option) => (
            <button
              key={option.value}
              onClick={() => handleSelect(option.value)}
              className={`block w-full px-4 py-2 text-sm text-left transition-colors ${
                fontSize === option.value
                  ? "bg-white text-black"
                  : "text-white hover:bg-white/10"
              }`}
              data-testid={`fontsize-${option.value}`}
            >
              {t(option.label)}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default FontSizeControl;
